function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Icon awesome-file-download",
    d: "M9.333 5.314V0H1a.968.968 0 0 0-1 .938v18.131a.968.968 0 0 0 1 .938h14a.968.968 0 0 0 1-.938V6.252h-5.667a.973.973 0 0 1-1-.938zm3.185 8.259L8.5 17.313a.744.744 0 0 1-1 0l-4.018-3.74a.621.621 0 0 1 .469-1.073h2.716V9.378a.647.647 0 0 1 .667-.625h1.333a.647.647 0 0 1 .667.625V12.5h2.716a.621.621 0 0 1 .469 1.074zm3.19-9.473L11.629.274A1.034 1.034 0 0 0 10.921 0h-.254v5H16v-.237a.906.906 0 0 0-.292-.663z",
    transform: "translate(4 2)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownload);
export default __webpack_public_path__ + "static/media/file_download.b457926e3bb37e36d6987a672bf5d218.svg";
export { ForwardRef as ReactComponent };